import { images } from '../constants';

const products = [ 
    {
        id: 1,
        image: images.product1Gallery1,
        name: 'Wrench Set', 
        price: 120,
        disprice: 110,
        stock: 8,
        content: "Upgrade your toolbox with our premium Wrench Set, designed for precision and durability. This set includes multiple wrench sizes, ensuring versatility for various tasks. Made from high-quality steel, it provides excellent torque and long-lasting performance. The ergonomic grip enhances comfort, reducing hand fatigue during extended use.",
        description: "Our Wrench Set is a must-have for both professionals and DIY enthusiasts. With a range of sizes and a corrosion-resistant finish, this set is perfect for automotive work, home repairs, and mechanical tasks. The compact storage case keeps your tools organized and easy to carry.",
        category: ['Tools & Equipment', 'Car Maintenance'],
        tags: ['Tools', 'Maintenance', 'Accessories'],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Chrome Vanadium Steel' },
            { id: 2, title: 'Sizes Included', content: '8mm - 22mm' },
            { id: 3, title: 'Finish', content: 'Corrosion-Resistant Coating' },
            { id: 4, title: 'Storage', content: 'Compact Carrying Case' },
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: 'James Parker',
                date: 'July 20, 2024',
                rating: 5,
                content: 'High-quality wrench set with a great grip! Perfect for my automotive projects.',
            },
            {
                id: 2,
                image: images.product1Review2,
                name: 'Emma Wilson',
                date: 'July 25, 2024',
                rating: 4.7,
                content: 'Great set for the price. Durable and easy to use!',
            },
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: 'Car Battery',
        price: 200,
        disprice: 185,
        stock: 5,
        content: "Power your vehicle with our high-performance AGM battery, engineered for reliable starts in extreme conditions. Featuring advanced spill-proof technology and deep-cycle capability, this battery delivers consistent power for modern vehicles with high electrical demands.",
        description: "This maintenance-free automotive battery is designed for superior performance in cars, trucks, and SUVs. With enhanced vibration resistance and optimized power output, it supports start-stop technology and provides exceptional cold cranking amps for reliable winter starts.",
        category: ['Car Maintenance', 'Automotive Accessories'],
        tags: ['Battery', 'Maintenance', 'Accessories'],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Voltage', content: '12V' },
            { id: 2, title: 'Cold Cranking Amps', content: '850 CCA' },
            { id: 3, title: 'Warranty', content: '36-Month Replacement' },
            { id: 4, title: 'Compatibility', content: 'SUV/Truck/Crossover' },
            { id: 5, title: 'Technology', content: 'AGM (Absorbent Glass Mat)' },
            { id: 6, title: 'Dimensions', content: 'L10.9" x W6.8" x H7.5"' },
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: 'Mike Johnson',
                date: 'January 15, 2024',
                rating: 4.9,
                content: 'Survived -20°C winter perfectly in my F-150. Quick installation and great power!',
            },
            {
                id: 2,
                image: images.product2Review2,
                name: 'Sarah Thompson',
                date: 'March 2, 2024',
                rating: 5,
                content: "Best aftermarket battery I've installed. Customers love the reliability and 3-year warranty.",
            },
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: 'Car Cover', 
        price: 180,
        disprice: 160,
        stock: 3,
        content: "Protect your vehicle from dust, rain, and UV rays with our Premium Car Cover. Designed with durable, weather-resistant fabric, it ensures all-season protection. The snug fit and elastic hems keep the cover secure even in windy conditions, while the breathable material prevents moisture buildup.",
        description: "Our Premium Car Cover is an essential accessory for car enthusiasts and daily drivers. It offers superior protection against scratches, bird droppings, and harsh weather conditions. The lightweight yet sturdy design makes it easy to install and store when not in use.",
        category: ['Exterior Accessories', 'Automotive Accessories'],
        tags: ['Protection', 'Exterior', 'Accessories'],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Waterproof Polyester Fabric' },
            { id: 2, title: 'Fit', content: 'Universal Fit for Sedans & SUVs' },
            { id: 3, title: 'Protection', content: 'UV-Resistant & Scratch-Proof' },
            { id: 4, title: 'Storage', content: 'Comes with a Compact Carry Bag' },
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: 'David Johnson',
                date: 'August 10, 2024',
                rating: 5,
                content: 'Great quality car cover! It keeps my vehicle clean and protected from harsh weather.',
            },
            {
                id: 2,
                image: images.product3Review2,
                name: 'Sophia Martinez',
                date: 'August 15, 2024',
                rating: 4.8,
                content: 'Fits my sedan perfectly! The fabric is strong and lightweight. Worth the price!',
            },
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: 'Seat Covers', 
        price: 220,
        disprice: 199,
        stock: 0,
        content: "Upgrade your car’s interior with our Luxury Car Seat Covers. Designed for comfort and style, these covers protect your seats from spills, stains, and wear while enhancing your driving experience. Made from premium, breathable materials, they ensure a perfect fit and long-lasting durability.",
        description: "Our Luxury Car Seat Covers are perfect for car owners looking to add elegance and protection to their vehicle. The easy-to-install design ensures a snug fit, while the soft padding provides extra comfort. Available in multiple colors and styles to match your car's interior.",
        category: ['Interior Accessories', 'Automotive Accessories'],
        tags: ['Interior', 'Protection', 'Accessories'],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Premium Leather & Breathable Fabric' },
            { id: 2, title: 'Fit', content: 'Universal Fit for Most Car Seats' },
            { id: 3, title: 'Protection', content: 'Water-Resistant & Scratch-Proof' },
            { id: 4, title: 'Installation', content: 'Easy Slip-On Design' },
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: 'Michael Thompson',
                date: 'August 18, 2024',
                rating: 5,
                content: 'Perfect seat covers! They fit my SUV well and add a premium touch to my car’s interior.',
            },
            {
                id: 2,
                image: images.product4Review2,
                name: 'Olivia Carter',
                date: 'August 22, 2024',
                rating: 4.9,
                content: 'Very comfortable and stylish. Installation was quick, and the material feels premium!',
            },
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: 'Tool Set', 
        price: 180,
        disprice: 165,
        stock: 9,
        content: "Be prepared for any repair with our Professional Auto Repair Tool Set. This comprehensive kit includes high-quality tools designed for precision and durability, making it perfect for both DIY car enthusiasts and professional mechanics.",
        description: "Our Professional Auto Repair Tool Set features a wide range of essential tools, including wrenches, screwdrivers, sockets, and pliers. With an ergonomic grip and a sturdy storage case, this set is ideal for automotive repairs, maintenance, and emergency roadside fixes.",
        category: ['Tools & Equipment', 'Car Maintenance'],
        tags: ['Tools', 'Maintenance', 'Accessories'],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Heavy-Duty Steel with Anti-Rust Coating' },
            { id: 2, title: 'Tools Included', content: 'Wrenches, Screwdrivers, Pliers, Sockets' },
            { id: 3, title: 'Storage', content: 'Compact & Durable Carrying Case' },
            { id: 4, title: 'Usage', content: 'Automotive Repairs & Maintenance' },
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: 'David Reynolds',
                date: 'August 25, 2024',
                rating: 5,
                content: 'Great toolset for my garage! Has everything I need for car repairs.',
            },
            {
                id: 2,
                image: images.product5Review2,
                name: 'Sophia Mitchell',
                date: 'August 28, 2024',
                rating: 4.8,
                content: 'High-quality tools and a sturdy case. Perfect for on-the-go fixes!',
            },
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: 'Roof Rack', 
        price: 250,
        disprice: 230,
        stock: 6,
        content: "Upgrade your vehicle's storage capacity with our Heavy-Duty Car Roof Rack. Designed for durability and versatility, this rack provides a secure and spacious platform for carrying luggage, camping gear, sports equipment, and more.",
        description: "Our Heavy-Duty Car Roof Rack is made from high-strength aluminum alloy with an anti-rust coating for long-lasting performance. It features an aerodynamic design to reduce wind resistance and noise, while the adjustable mounting system ensures a universal fit for most vehicles. Ideal for road trips, outdoor adventures, and everyday cargo transportation.",
        category: ['Exterior Accessories', 'Automotive Accessories'],
        tags: ['Exterior', 'Protection', 'Accessories'],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'High-Strength Aluminum Alloy' },
            { id: 2, title: 'Load Capacity', content: 'Up to 165 lbs (75 kg)' },
            { id: 3, title: 'Mounting System', content: 'Adjustable & Universal Fit' },
            { id: 4, title: 'Weather Resistance', content: 'Rust-Proof & Waterproof Coating' },
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: 'Michael Thompson',
                date: 'September 5, 2024',
                rating: 5,
                content: 'Solid and sturdy roof rack! Perfect for my weekend road trips.',
            },
            {
                id: 2,
                image: images.product6Review2,
                name: 'Emily Carter',
                date: 'September 10, 2024',
                rating: 4.7,
                content: 'Easy to install and great build quality. Holds my gear securely.',
            },
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: 'Car Jack', 
        price: 180,
        disprice: 165,
        stock: 2,
        content: "Ensure safe and effortless vehicle lifting with our Heavy-Duty Hydraulic Car Jack. Designed for strength and stability, this jack is perfect for tire changes, maintenance, and emergency roadside repairs.",
        description: "Our Heavy-Duty Hydraulic Car Jack is made from reinforced steel for maximum durability and a high load capacity. The hydraulic system provides smooth and effortless lifting, while the wide base enhances stability on various surfaces. With a compact design, it fits easily in your trunk for on-the-go convenience.",
        category: ['Tools & Equipment', 'Car Maintenance'],
        tags: ['Tools', 'Maintenance', 'Accessories'],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Reinforced Heavy-Duty Steel' },
            { id: 2, title: 'Load Capacity', content: 'Up to 3 Tons (6000 lbs)' },
            { id: 3, title: 'Lifting Range', content: '5" to 20" (12cm to 50cm)' },
            { id: 4, title: 'Mechanism', content: 'Hydraulic Lift System' },
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: 'David Robinson',
                date: 'September 15, 2024',
                rating: 5,
                content: 'Reliable and easy to use! Perfect for my garage and emergency situations.',
            },
            {
                id: 2,
                image: images.product7Review2,
                name: 'Sophia Martinez',
                date: 'September 18, 2024',
                rating: 4.8,
                content: 'Strong and stable. Lifted my SUV effortlessly!',
            },
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: 'Microfiber Cloths', 
        price: 25,
        disprice: 20,
        stock: 0,
        content: "Keep your vehicle spotless with our ultra-soft and highly absorbent Premium Microfiber Cloths. Designed for streak-free cleaning, these cloths are perfect for detailing, drying, and polishing your car.",
        description: "Our Premium Microfiber Cloths are made from high-quality fibers that trap dust, dirt, and grime without scratching the surface. Ideal for both interior and exterior cleaning, these cloths work well with water, wax, or cleaning sprays. Reusable and machine washable, they provide long-lasting performance.",
        category: ['Car Maintenance', 'Interior Accessories'],
        tags: ['Cleaning', 'Interior', 'Maintenance'],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: '80% Polyester, 20% Polyamide' },
            { id: 2, title: 'Size', content: '16" x 16" (40cm x 40cm)' },
            { id: 3, title: 'Usage', content: 'Interior & Exterior Cleaning' },
            { id: 4, title: 'Care', content: 'Machine Washable & Reusable' },
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: 'Michael Johnson',
                date: 'October 5, 2024',
                rating: 5,
                content: 'Super soft and highly absorbent! Works great for waxing and drying.',
            },
            {
                id: 2,
                image: images.product8Review2,
                name: 'Emily Davis',
                date: 'October 8, 2024',
                rating: 4.9,
                content: 'Absolutely love these microfiber cloths! No streaks and very durable.',
            },
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: 'Floor Mats', 
        price: 60,
        disprice: 50,
        stock: 9,
        content: "Protect your car’s interior with our durable All-Weather Car Floor Mats. Designed to trap dirt, mud, and spills, these mats provide excellent coverage and easy maintenance for a cleaner ride.",
        description: "Our premium-quality Floor Mats are crafted from heavy-duty rubber and feature deep grooves to catch debris, ensuring your car stays clean in all seasons. The anti-slip backing keeps them securely in place, while the universal fit ensures compatibility with most vehicles. Easy to clean and highly durable, these mats offer the perfect blend of style and functionality.",
        category: ['Interior Accessories', 'Automotive Accessories'],
        tags: ['Car Interior', 'Floor Protection', 'Weatherproof'],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Heavy-Duty Rubber' },
            { id: 2, title: 'Fit', content: 'Universal for Most Vehicles' },
            { id: 3, title: 'Features', content: 'Waterproof, Anti-Slip, Easy to Clean' },
            { id: 4, title: 'Design', content: 'Deep Grooves for Maximum Dirt Trapping' },
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: 'Daniel Thompson',
                date: 'October 12, 2024',
                rating: 5,
                content: 'Perfect fit for my SUV! Keeps my car clean and looks great.',
            },
            {
                id: 2,
                image: images.product9Review2,
                name: 'Sophia Carter',
                date: 'October 15, 2024',
                rating: 4.8,
                content: 'Durable and easy to clean! The anti-slip backing is a great touch.',
            },
        ]
    },
        {
        id: 1,
        image: images.product1Gallery1,
        name: 'Wrench Set', 
        price: 120,
        disprice: 110,
        stock: 8,
        content: "Upgrade your toolbox with our premium Wrench Set, designed for precision and durability. This set includes multiple wrench sizes, ensuring versatility for various tasks. Made from high-quality steel, it provides excellent torque and long-lasting performance. The ergonomic grip enhances comfort, reducing hand fatigue during extended use.",
        description: "Our Wrench Set is a must-have for both professionals and DIY enthusiasts. With a range of sizes and a corrosion-resistant finish, this set is perfect for automotive work, home repairs, and mechanical tasks. The compact storage case keeps your tools organized and easy to carry.",
        category: ['Tools & Equipment', 'Car Maintenance'],
        tags: ['Tools', 'Maintenance', 'Accessories'],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Chrome Vanadium Steel' },
            { id: 2, title: 'Sizes Included', content: '8mm - 22mm' },
            { id: 3, title: 'Finish', content: 'Corrosion-Resistant Coating' },
            { id: 4, title: 'Storage', content: 'Compact Carrying Case' },
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: 'James Parker',
                date: 'July 20, 2024',
                rating: 5,
                content: 'High-quality wrench set with a great grip! Perfect for my automotive projects.',
            },
            {
                id: 2,
                image: images.product1Review2,
                name: 'Emma Wilson',
                date: 'July 25, 2024',
                rating: 4.7,
                content: 'Great set for the price. Durable and easy to use!',
            },
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: 'Car Battery',
        price: 200,
        disprice: 185,
        stock: 8,
        content: "Power your vehicle with our high-performance AGM battery, engineered for reliable starts in extreme conditions. Featuring advanced spill-proof technology and deep-cycle capability, this battery delivers consistent power for modern vehicles with high electrical demands.",
        description: "This maintenance-free automotive battery is designed for superior performance in cars, trucks, and SUVs. With enhanced vibration resistance and optimized power output, it supports start-stop technology and provides exceptional cold cranking amps for reliable winter starts.",
        category: ['Car Maintenance', 'Automotive Accessories'],
        tags: ['Battery', 'Maintenance', 'Accessories'],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Voltage', content: '12V' },
            { id: 2, title: 'Cold Cranking Amps', content: '850 CCA' },
            { id: 3, title: 'Warranty', content: '36-Month Replacement' },
            { id: 4, title: 'Compatibility', content: 'SUV/Truck/Crossover' },
            { id: 5, title: 'Technology', content: 'AGM (Absorbent Glass Mat)' },
            { id: 6, title: 'Dimensions', content: 'L10.9" x W6.8" x H7.5"' },
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: 'Mike Johnson',
                date: 'January 15, 2024',
                rating: 4.9,
                content: 'Survived -20°C winter perfectly in my F-150. Quick installation and great power!',
            },
            {
                id: 2,
                image: images.product2Review2,
                name: 'Sarah Thompson',
                date: 'March 2, 2024',
                rating: 5,
                content: "Best aftermarket battery I've installed. Customers love the reliability and 3-year warranty.",
            },
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: 'Car Cover', 
        price: 180,
        disprice: 160,
        stock: 8,
        content: "Protect your vehicle from dust, rain, and UV rays with our Premium Car Cover. Designed with durable, weather-resistant fabric, it ensures all-season protection. The snug fit and elastic hems keep the cover secure even in windy conditions, while the breathable material prevents moisture buildup.",
        description: "Our Premium Car Cover is an essential accessory for car enthusiasts and daily drivers. It offers superior protection against scratches, bird droppings, and harsh weather conditions. The lightweight yet sturdy design makes it easy to install and store when not in use.",
        category: ['Exterior Accessories', 'Automotive Accessories'],
        tags: ['Protection', 'Exterior', 'Accessories'],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Waterproof Polyester Fabric' },
            { id: 2, title: 'Fit', content: 'Universal Fit for Sedans & SUVs' },
            { id: 3, title: 'Protection', content: 'UV-Resistant & Scratch-Proof' },
            { id: 4, title: 'Storage', content: 'Comes with a Compact Carry Bag' },
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: 'David Johnson',
                date: 'August 10, 2024',
                rating: 5,
                content: 'Great quality car cover! It keeps my vehicle clean and protected from harsh weather.',
            },
            {
                id: 2,
                image: images.product3Review2,
                name: 'Sophia Martinez',
                date: 'August 15, 2024',
                rating: 4.8,
                content: 'Fits my sedan perfectly! The fabric is strong and lightweight. Worth the price!',
            },
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: 'Seat Covers', 
        price: 220,
        disprice: 199,
        stock: 8,
        content: "Upgrade your car’s interior with our Luxury Car Seat Covers. Designed for comfort and style, these covers protect your seats from spills, stains, and wear while enhancing your driving experience. Made from premium, breathable materials, they ensure a perfect fit and long-lasting durability.",
        description: "Our Luxury Car Seat Covers are perfect for car owners looking to add elegance and protection to their vehicle. The easy-to-install design ensures a snug fit, while the soft padding provides extra comfort. Available in multiple colors and styles to match your car's interior.",
        category: ['Interior Accessories', 'Automotive Accessories'],
        tags: ['Interior', 'Protection', 'Accessories'],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Premium Leather & Breathable Fabric' },
            { id: 2, title: 'Fit', content: 'Universal Fit for Most Car Seats' },
            { id: 3, title: 'Protection', content: 'Water-Resistant & Scratch-Proof' },
            { id: 4, title: 'Installation', content: 'Easy Slip-On Design' },
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: 'Michael Thompson',
                date: 'August 18, 2024',
                rating: 5,
                content: 'Perfect seat covers! They fit my SUV well and add a premium touch to my car’s interior.',
            },
            {
                id: 2,
                image: images.product4Review2,
                name: 'Olivia Carter',
                date: 'August 22, 2024',
                rating: 4.9,
                content: 'Very comfortable and stylish. Installation was quick, and the material feels premium!',
            },
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: 'Tool Set', 
        price: 180,
        disprice: 165,
        stock: 8,
        content: "Be prepared for any repair with our Professional Auto Repair Tool Set. This comprehensive kit includes high-quality tools designed for precision and durability, making it perfect for both DIY car enthusiasts and professional mechanics.",
        description: "Our Professional Auto Repair Tool Set features a wide range of essential tools, including wrenches, screwdrivers, sockets, and pliers. With an ergonomic grip and a sturdy storage case, this set is ideal for automotive repairs, maintenance, and emergency roadside fixes.",
        category: ['Tools & Equipment', 'Car Maintenance'],
        tags: ['Tools', 'Maintenance', 'Accessories'],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Heavy-Duty Steel with Anti-Rust Coating' },
            { id: 2, title: 'Tools Included', content: 'Wrenches, Screwdrivers, Pliers, Sockets' },
            { id: 3, title: 'Storage', content: 'Compact & Durable Carrying Case' },
            { id: 4, title: 'Usage', content: 'Automotive Repairs & Maintenance' },
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: 'David Reynolds',
                date: 'August 25, 2024',
                rating: 5,
                content: 'Great toolset for my garage! Has everything I need for car repairs.',
            },
            {
                id: 2,
                image: images.product5Review2,
                name: 'Sophia Mitchell',
                date: 'August 28, 2024',
                rating: 4.8,
                content: 'High-quality tools and a sturdy case. Perfect for on-the-go fixes!',
            },
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: 'Roof Rack', 
        price: 250,
        disprice: 230,
        stock: 8,
        content: "Upgrade your vehicle's storage capacity with our Heavy-Duty Car Roof Rack. Designed for durability and versatility, this rack provides a secure and spacious platform for carrying luggage, camping gear, sports equipment, and more.",
        description: "Our Heavy-Duty Car Roof Rack is made from high-strength aluminum alloy with an anti-rust coating for long-lasting performance. It features an aerodynamic design to reduce wind resistance and noise, while the adjustable mounting system ensures a universal fit for most vehicles. Ideal for road trips, outdoor adventures, and everyday cargo transportation.",
        category: ['Exterior Accessories', 'Automotive Accessories'],
        tags: ['Exterior', 'Protection', 'Accessories'],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'High-Strength Aluminum Alloy' },
            { id: 2, title: 'Load Capacity', content: 'Up to 165 lbs (75 kg)' },
            { id: 3, title: 'Mounting System', content: 'Adjustable & Universal Fit' },
            { id: 4, title: 'Weather Resistance', content: 'Rust-Proof & Waterproof Coating' },
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: 'Michael Thompson',
                date: 'September 5, 2024',
                rating: 5,
                content: 'Solid and sturdy roof rack! Perfect for my weekend road trips.',
            },
            {
                id: 2,
                image: images.product6Review2,
                name: 'Emily Carter',
                date: 'September 10, 2024',
                rating: 4.7,
                content: 'Easy to install and great build quality. Holds my gear securely.',
            },
        ]
    },
];

export default products;